import { API_FOC_ORDERS } from 'utils/constants'
import Api from './axiosInstance'

type GetOrderStoreCodeParams = {
  orderNo: string
}

type FetchOrdersParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

export type FocOrderItem = {
  barcodeNo: string
  itemDesc?: string
  itemUom?: string
  vatAmount: number
  lineAmountInclVAT: number
  lineAmountExclVAT: number
}

export type CreateFocOrderPayload = {
  locationCode: string
  appliesToMagentoOrderNo?: string
  totalAmountExclVAT: number
  totalVATAmount: number
  totalAmountInclVAT: number
  items: FocOrderItem[]
}

export const getOrderStoreCode = ({ orderNo }: GetOrderStoreCodeParams) => {
  return Api.get({
    url: `${API_FOC_ORDERS.ORDER}/${orderNo}/storeCode`,
  })
}
export const getBarcodePrice = ({
  barcode,
  storeCode,
}: {
  barcode: string
  storeCode: string
}) => {
  return Api.get({
    url: `${API_FOC_ORDERS.BARCODE_PRICE}?barcode=${barcode}&storeCode=${storeCode}`,
  })
}

export const fetchFocOrder = (orderNo: string) => {
  return Api.get({ url: `${API_FOC_ORDERS.ORDER}/${orderNo}` })
}

export const fetchFocOrders = ({
  limit,
  page,
  search,
  filters,
}: FetchOrdersParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_FOC_ORDERS.ORDER}?${params}`,
  })
}

export const createFocRMA = ({
  id,
  data,
}: {
  id: string
  data: { reason: string; condition: string; orderNo: string }
}) => {
  return Api.post({
    url: `${API_FOC_ORDERS.ORDER}/${id}/rma`,
    data,
  })
}

export const createFocOrder = (data: CreateFocOrderPayload) => {
  return Api.post({
    url: `${API_FOC_ORDERS.ORDER}`,
    data,
  })
}

export const exportFocOrders = ({
  filters,
}: {
  filters: Record<string, any>
}) => {
  const params = new URLSearchParams(filters)

  return Api.get({
    url: `${API_FOC_ORDERS.EXPORT}?${params}`,
  })
}

export const triggerFocOrderSync = () => {
  return Api.post({ url: API_FOC_ORDERS.ORDERS_SYNC })
}
